import styled from 'styled-components'
import { useNavigate } from 'react-router-dom' // Importer useNavigate
import associateItemWithDatabase from '../../utils/services/associateItemWithDatabase'
import ItemImpact from './ItemImpact'
import formatDateToSwiss from '../../utils/services/formatDateToSwiss'
import ItemPrice from './ItemPrice'

const ArticleShort = ({ sellOrBuySection, stuffCategories, item, width }) => {
    const navigate = useNavigate() // Initialiser le hook useNavigate

    if (item && stuffCategories) {
        const itemInfo = associateItemWithDatabase(
            stuffCategories,
            item.category
        )
        item.impactMoney = (itemInfo.impactMoney * item.quantity).toFixed(2)
        item.impactCO2 = (itemInfo.impactCO2 * item.quantity).toFixed(3)
        item.impactTrash = (itemInfo.impactTrash * item.quantity).toFixed(3)

        const StyledArticleShort = styled.div`
            color: white;
            position: relative;
            display: flex;
            align-content: space-between;
            justify-content: space-between;
            width: ${(props) => props.width || '98%'};
            padding-left: 10px;
            margin-top: 5px;
            border-radius: 20px;
            background-color: ${itemInfo.backgroundColor || '#FFFFFF'};
            transition: all 0.1s ease;
            filter: brightness(
                ${item.status === 'active'
                    ? 1
                    : item.status === 'pending'
                    ? 0.6
                    : item.status === 'sold'
                    ? 0.35
                    : '#FFFFFF'}
            );
            &:hover {
                filter: brightness(0.9);
                cursor: pointer;
            }
        `

        const StyledArticleShortLeft = styled.div`
            display: flex;
            justify-content: center;
            gap: 10px;
        `

        const StyledImg = styled.div`
            position: relative;
            width: 100px;
            height: 100px;
            margin: 10px 0;
            & img {
                position: absolute;
                top: 0;
                right: 0;
                height: 100%;
                object-fit: cover;
                aspect-ratio: 1/1;
                border-radius: 15px;
                z-index: 1;
            }
            & div {
                position: absolute;
                font-size: 60%;
                background-color: #006200;
                border-radius: 1vh 0 1vh 0;
                color: white;
                top: -0.8vh;
                right: -1vh;
                padding: 0.5vh;
                z-index: 2;
            }
        `
        const StyledItemStatus = styled.div`
            display: flex;
            font-size: 110%;
        `

        const StyledItemDescription = styled.div`
            display: flex;
            flex-direction: column;
            padding: 5px 0;
        `

        const StyledItemTitle = styled.div`
            font-weight: bold;
            font-size: 140%;
            padding: 5px 0;
        `

        const StyledItemCategory = styled.div`
            font-size: 80%;
        `

        const StyledItemExpiringDate = styled.div`
            font-size: 80%;
        `
        const StyledItemDistance = styled.div`
            font-size: 80%;
        `
        const StyledArticleShortRight = styled.div`
            display: flex;
            flex-direction: column;
            justify-content: space-between;
        `

        const handleClick = () => {
            navigate(`/Product/${item._id}`) // Rediriger vers la page cible avec l'ID de l'item
        }

        return (
            <StyledArticleShort onClick={handleClick} width={width}>
                <StyledArticleShortLeft>
                    <StyledImg>
                        <img src={item.imageUrl} alt="stuff" />
                        {item.isBio && <div>Bio</div>}
                    </StyledImg>
                    <StyledItemDescription>
                        <StyledItemTitle>{item.title}</StyledItemTitle>
                        <StyledItemCategory>
                            {itemInfo.category} · {itemInfo.subcategory} ·{' '}
                            {item.category}
                        </StyledItemCategory>
                        <StyledItemExpiringDate>
                            Péremption :{' '}
                            {item.expiringDate
                                ? formatDateToSwiss(item.expiringDate)
                                : 'Non périssable'}
                        </StyledItemExpiringDate>
                        {sellOrBuySection === 'buy' && item?.distance > 0 && (
                            <StyledItemDistance>
                                Distance : {(item?.distance / 1000).toFixed(1)}{' '}
                                km
                            </StyledItemDistance>
                        )}
                        <StyledItemStatus>
                            {item.status === 'active'
                                ? ''
                                : item.status === 'pending'
                                ? '(en attente de validation)'
                                : item.status === 'sold'
                                ? '(vendu)'
                                : '(erreur)'}
                        </StyledItemStatus>
                    </StyledItemDescription>
                </StyledArticleShortLeft>
                <StyledArticleShortRight>
                    <ItemPrice item={item} />
                    <ItemImpact item={item} />
                </StyledArticleShortRight>
            </StyledArticleShort>
        )
    } else {
        return <div>Chargement en cours...</div>
    }
}

export default ArticleShort
